import React, { useState, useEffect } from 'react';
import { LifeBuoy, ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { useAuth } from '../../contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const STATUS_STYLES = {
  open: 'bg-red-100 text-red-700 border-red-300',
  in_progress: 'bg-blue-100 text-blue-700 border-blue-300',
  resolved: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  closed: 'bg-slate-100 text-slate-600 border-slate-300'
};

export const MyTickets = () => {
  const { token } = useAuth();
  const [tickets, setTickets] = useState([]);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (!token) return;
    const fetcher = window.__origFetch || window.fetch;
    fetcher(`${BACKEND_URL}/api/support/tickets/my`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((r) => r.json())
      .then((d) => d.success && setTickets(d.tickets))
      .catch(() => {});
  }, [token]);

  if (tickets.length === 0) return null;

  return (
    <Card className="mt-8 shadow-lg" data-testid="my-tickets-section">
      <CardHeader className="cursor-pointer" onClick={() => setExpanded(!expanded)}>
        <CardTitle className="flex items-center justify-between text-lg">
          <span className="flex items-center gap-2"><LifeBuoy className="w-5 h-5 text-orange-500" /> My Support Tickets ({tickets.length})</span>
          {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </CardTitle>
      </CardHeader>
      {expanded && (
        <CardContent className="space-y-3">
          {tickets.map((t) => (
            <div key={t.ticket_id} className="border border-slate-200 rounded-xl p-4" data-testid={`ticket-${t.ticket_id}`}>
              <div className="flex items-center justify-between flex-wrap gap-2 mb-1">
                <span className="font-bold text-sm text-slate-900">{t.ticket_id} · {t.feature}</span>
                <Badge className={`border ${STATUS_STYLES[t.status] || STATUS_STYLES.open}`}>{t.status.replace('_', ' ')}</Badge>
              </div>
              {t.error_message && <p className="text-xs text-slate-500 break-words">{t.error_message}</p>}
              {t.description && <p className="text-sm text-slate-700 mt-1">"{t.description}"</p>}
              {t.admin_note && (
                <div className="mt-2 text-sm bg-blue-50 border border-blue-200 rounded-lg p-2 text-blue-900">
                  <strong>Team response:</strong> {t.admin_note}
                </div>
              )}
              <p className="text-xs text-slate-400 mt-2">Reported {new Date(t.created_at).toLocaleString()}</p>
            </div>
          ))}
        </CardContent>
      )}
    </Card>
  );
};

export default MyTickets;
